import { map, _map } from "./map";

/**
 * {@inheritDoc map}
 */

export const select = map;
/**
 * {@inheritDoc _map}
 */
export const _select = _map;
